import { Auth, SocialAccount } from '@/type';
import { Credentials } from '@/iam/external';
import eventBus from '@/messaging/event-bus';
import { SocialAccountDeleted } from '@/messaging/events';
import { Account, UpdateAccountData } from '../types';
import api from '../API';

export class AccountAdded {
  static eventName = 'social.account.added'

  account: Account;

  constructor(account: Account) {
    this.account = account;
  }
}

interface NewAccount {
  clientId: number,
  socialSiteId: number,
  auth?: Auth,
  credentials?: Credentials,
  externalId?: string
}

export async function add(newAccount: NewAccount): Promise<Account> {
  const response = await api.post(
    `clients/${newAccount.clientId}/accounts`,
    newAccount,
  );
  const account = response.data;
  eventBus.$emit(AccountAdded.eventName, new AccountAdded(account));
  return account;
}

export function requiresReconnect(socialAccount: Account): boolean {
  return (socialAccount.reconnectRequest !== null);
}

export function requiresClientAction(account: Account): boolean {
  return (account.reconnectRequest !== null && account.reconnectRequest.assignee === 'client');
}

export function deleteSocialAccount(socialAccount: SocialAccount): Promise<void> {
  return api
    .delete(`accounts/${socialAccount.id}`)
    .then(() => {
      eventBus.$emit(SocialAccountDeleted.eventName, new SocialAccountDeleted(socialAccount));
    });
}

export async function update(id: number, data: UpdateAccountData): Promise<Account> {
  return api
    .put(`accounts/${id}`, data)
    .then(response => response.data);
}
